import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { db } from "../firebase";
import { collection, addDoc, doc, getDoc } from "firebase/firestore";

const DataEntryForm = ({ onSuccess }) => {
  const [form, setForm] = useState({
    grade: "9",
    subject: "",
    chapters: [
      {
        chapterTitle: "",
        notes: [{ title: "", url: "" }],
        questions: [{ title: "", url: "" }],
        lectures: [{ title: "", url: "" }]
      }
    ]
  });

  const [subjects, setSubjects] = useState({});

  useEffect(() => {
    const fetchSubjects = async () => {
      const ref = doc(db, "subjects", form.grade);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setSubjects(snap.data());
      } else {
        setSubjects({});
      }
    };
    fetchSubjects();
  }, [form.grade]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleChapterChange = (index, field, value) => {
    const updatedChapters = [...form.chapters];
    updatedChapters[index][field] = value;
    setForm({ ...form, chapters: updatedChapters });
  };

  const handleResourceChange = (chapterIndex, type, resourceIndex, field, value) => {
    const updatedChapters = [...form.chapters];
    updatedChapters[chapterIndex][type][resourceIndex][field] = value;
    setForm({ ...form, chapters: updatedChapters });
  };

  const addChapter = () => {
    setForm({
      ...form,
      chapters: [
        ...form.chapters,
        {
          chapterTitle: "",
          notes: [{ title: "", url: "" }],
          questions: [{ title: "", url: "" }],
          lectures: [{ title: "", url: "" }]
        }
      ]
    });
  };

  const addResource = (chapterIndex, type) => {
    const updatedChapters = [...form.chapters];
    updatedChapters[chapterIndex][type].push({ title: "", url: "" });
    setForm({ ...form, chapters: updatedChapters });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { grade, subject, chapters } = form;

    if (!grade || !subject || chapters.length === 0) {
      alert("Please fill out class, subject, and at least one chapter.");
      return;
    }

    try {
      for (const chapter of chapters) {
        await addDoc(collection(db, "resources"), {
          grade,
          subject,
          ...chapter,
          timestamp: Date.now()
        });
      }

      alert("✅ Data successfully added to Firebase!");

      if (onSuccess) onSuccess();

      setForm({
        grade,
        subject,
        chapters: [
          {
            chapterTitle: "",
            notes: [{ title: "", url: "" }],
            questions: [{ title: "", url: "" }],
            lectures: [{ title: "", url: "" }]
          }
        ]
      });
    } catch (error) {
      console.error("❌ Error saving to Firebase:", error);
      alert("Something went wrong. Check console.");
    }
  };

  return (
    <Container className="mt-5 p-4 bg-white rounded shadow">
      <h3 className="mb-4 text-center">📝 Add Resources by Chapter</h3>

      <Form onSubmit={handleSubmit}>
        {/* Class and Subject Selectors */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Label>Class</Form.Label>
            <Form.Select name="grade" value={form.grade} onChange={handleChange}>
              {["9", "10", "11", "12"].map((g) => (
                <option key={g} value={g}>Class {g}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6}>
            <Form.Label>Subject</Form.Label>
            <Form.Select name="subject" value={form.subject} onChange={handleChange}>
              <option value="">Select Subject</option>
              {Object.entries(subjects).map(([key, label]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        {/* Chapters */}
        {form.chapters.map((chapter, chapterIndex) => (
          <div key={chapterIndex} className="border rounded p-3 mb-4">
            <Form.Group className="mb-3">
              <Form.Label>Chapter Title</Form.Label>
              <Form.Control
                value={chapter.chapterTitle}
                onChange={(e) => handleChapterChange(chapterIndex, "chapterTitle", e.target.value)}
              />
            </Form.Group>

            {/* Resource Groups */}
            {["notes", "questions", "lectures"].map((type) => (
              <div key={type} className="mb-3">
                <h6 className="text-capitalize">{type}</h6>
                {chapter[type].map((res, resIndex) => (
                  <Row key={resIndex} className="mb-2">
                    <Col md={6}>
                      <Form.Control
                        placeholder={`${type.slice(0, -1)} title`}
                        value={res.title}
                        onChange={(e) =>
                          handleResourceChange(chapterIndex, type, resIndex, "title", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <Form.Control
                        placeholder={`${type.slice(0, -1)} URL`}
                        value={res.url}
                        onChange={(e) =>
                          handleResourceChange(chapterIndex, type, resIndex, "url", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                ))}
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => addResource(chapterIndex, type)}
                >
                  ➕ Add {type.slice(0, -1)}
                </Button>
              </div>
            ))}
          </div>
        ))}

        <div className="d-flex justify-content-between">
          <Button variant="secondary" onClick={addChapter}>➕ Add Chapter</Button>
          <Button type="submit" variant="success">✅ Submit</Button>
        </div>
      </Form>
    </Container>
  );
};

export default DataEntryForm;
